import React, { useEffect, useState } from "react";
import { LayoutTemplate, ChevronDown } from "lucide-react";
import { adminApi } from "../../lib/api";

// Dropdown that lists admin-managed content templates of a given kind and
// applies the chosen one. Confirms before overwriting existing content.
export default function TemplatePicker({ kind, onApply, hasContent, label = "Start from a template" }) {
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    adminApi.contentTemplates.list()
      .then((all) => setTemplates((all || []).filter((t) => t.kind === kind)))
      .catch(() => setTemplates([]));
  }, [kind]);

  if (templates.length === 0) return null;

  const pick = (t) => {
    setOpen(false);
    if (hasContent && hasContent() && !window.confirm("This will replace the current content with the template. Continue?")) return;
    onApply(t);
  };

  return (
    <div className="relative inline-block" data-testid={`template-picker-${kind}`}>
      <button
        type="button"
        data-testid={`template-picker-toggle-${kind}`}
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy bg-slate-100 hover:bg-slate-200 rounded-full px-3.5 py-1.5 transition-colors"
      >
        <LayoutTemplate size={14} /> {label}
        <ChevronDown size={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-2 w-72 bg-white rounded-xl border border-slate-200 shadow-lg overflow-hidden">
            {templates.map((t) => (
              <button
                key={t.id}
                type="button"
                data-testid={`template-option-${t.id}`}
                onClick={() => pick(t)}
                className="w-full text-left px-4 py-2.5 hover:bg-slate-50 transition-colors border-b border-slate-50 last:border-b-0"
              >
                <p className="text-sm font-semibold text-navy">{t.name}</p>
                {t.description && <p className="text-xs text-slate-400 mt-0.5 leading-snug">{t.description}</p>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
